import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { fireHeapEvent } from '../helpers'
import eventNames from '../constants/tagging'

export enum PillsStatus {
  selected,
  unselected,
  unavailable
}

const e = {
  Revenue_SignUpPage_Clicked_SignUpButton(signupButtonType: string): void {
    const { Revenue_SignUpPage_Clicked_SignUpButton } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_SignUpButton, { signupButtonType })
  },
  Revenue_SignUpPage_Clicked_SignInButton(): void {
    const { Revenue_SignUpPage_Clicked_SignInButton } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_SignInButton)
  },
  Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox(isChecked: boolean): void {
    const { Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox, { isChecked })
  },
  Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox(): void {
    const { Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox)
  },

  Revenue_TaggingPage_Viewed_Page(): void {
    const { Revenue_TaggingPage_Viewed_Page } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Viewed_Page)
  },

  Revenue_TaggingPage_Clicked_WhatDoYouDoDropdown(): void {
    const { Revenue_TaggingPage_Clicked_WhatDoYouDoDropdown } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Clicked_WhatDoYouDoDropdown)
  },
  Revenue_TaggingPage_Selected_WhatDoYouDoDropdownOption(role: string): void {
    const { Revenue_TaggingPage_Selected_WhatDoYouDoDropdownOption } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Selected_WhatDoYouDoDropdownOption, { role })
  },
  Revenue_TaggingPage_Typed_OtherRole(role: string): void {
    const { Revenue_TaggingPage_Typed_OtherRole } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Typed_OtherRole, { role })
  },

  Revenue_TaggingPage_Selected_WhatDoesYourCompanyDoPill(industry: string): void {
    const { Revenue_TaggingPage_Selected_WhatDoesYourCompanyDoPill } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Selected_WhatDoesYourCompanyDoPill, { industry })
  },
  Revenue_TaggingPage_Unselected_WhatDoesYourCompanyDoPill(industry: string): void {
    const { Revenue_TaggingPage_Unselected_WhatDoesYourCompanyDoPill } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Unselected_WhatDoesYourCompanyDoPill, { industry })
  },
  Revenue_TaggingPage_ClickedOn_WhatDoesYourCompanyDoPill(
    industry: string,
    status: PillsStatus
  ): void {
    const { Revenue_TaggingPage_ClickedOn_WhatDoesYourCompanyDoPill } = eventNames
    fireHeapEvent(Revenue_TaggingPage_ClickedOn_WhatDoesYourCompanyDoPill, { industry, status })
  },

  Revenue_TaggingPage_Selected_HowWillYouUseThisPill(usecase: string): void {
    const { Revenue_TaggingPage_Selected_HowWillYouUseThisPill } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Selected_HowWillYouUseThisPill, { usecase })
  },
  Revenue_TaggingPage_Unselected_HowWillYouUseThisPill(usecase: string): void {
    const { Revenue_TaggingPage_Unselected_HowWillYouUseThisPill } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Unselected_HowWillYouUseThisPill, { usecase })
  },
  Revenue_TaggingPage_ClickedOn_HowWillYouUseThisPill(industry: string, status: PillsStatus): void {
    const { Revenue_TaggingPage_ClickedOn_HowWillYouUseThisPill } = eventNames
    fireHeapEvent(Revenue_TaggingPage_ClickedOn_HowWillYouUseThisPill, { industry, status })
  },

  Revenue_TaggingPage_Clicked_SignUpPlanButton(buttonType: PlanType, upsellPlan: PlanType): void {
    const { Revenue_TaggingPage_Clicked_SignUpPlanButton } = eventNames
    fireHeapEvent(Revenue_TaggingPage_Clicked_SignUpPlanButton, { buttonType, upsellPlan })
  },
  Revenue_TaggingPage_Clicked_Next(step: string): void {
    fireHeapEvent(eventNames.Revenue_TaggingPage_Clicked_Next, { step })
  },
  Revenue_TaggingPage_Clicked_ProgressBar(step: string): void {
    fireHeapEvent(eventNames.Revenue_TaggingPage_Clicked_ProgressBar, { step })
  }
}

export default e
